module.exports = __webpack_public_path__ + "static/img/深交所行情授权.ab677e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/深交所行情授权.jpg
// module id = ou4b
// module chunks = 1